import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/route_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  destination_id_eq: {
    column_type: 'belongs_to',
    column_name: 'destination',
    extra: {
      model_name: 'Station',
    },
    model_name: 'Route',
  },
  destination: {
    column_type: 'belongs_to',
    column_name: 'destination',
    extra: {
      model_name: 'Station',
    },
    model_name: 'Route',
  },
  origin_id_eq: {
    column_type: 'belongs_to',
    column_name: 'origin',
    extra: {
      model_name: 'Station',
    },
    model_name: 'Route',
  },
  origin: {
    column_type: 'belongs_to',
    column_name: 'origin',
    extra: {
      model_name: 'Station',
    },
    model_name: 'Route',
  },
  active_eq: {
    column_type: 'boolean',
    model_name: 'Route',
    column_name: 'active',
  },
  round_trip_eq: {
    column_type: 'boolean',
    model_name: 'Route',
    column_name: 'roundTrip',
  },
}
export const formColumnsConfig = {
  'self': {
    'destination_id': { required: true, disabledUpdate: false },
    'origin_id': { required: true, disabledUpdate: false },
    'active': { required: false, disabledUpdate: false },
    'round_trip': { required: false, disabledUpdate: false },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('Route', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('Route', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
